import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { AuditsTable } from '../../components/auditsTable/AuditsTable';
import { setBackButton, setPageTitle } from '../../features/header/headerSlice';
import { useGetAudits } from '../../features/audit/auditApi'

//constants
import { AUDIT_ENTITY } from '../../components/auditsTable/constants';
import { useHistory } from 'react-router';

const VehicleModelPollAudits = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { data, isFetching, refetch } = useGetAudits(AUDIT_ENTITY.VEHICLE_MODEL_POLL, history.location.state.id);
  const pageTitle = !history.location.state.name
    ? t('Audits.AuditHistory')
    : t('Audits.AuditHistoryFor', { name: history.location.state.name });

  useEffect(() => {
    dispatch(setBackButton(true));
    dispatch(setPageTitle(pageTitle));
  }, [pageTitle, dispatch]);

  return <AuditsTable audits={data} isFetching={isFetching} />;
};

export default VehicleModelPollAudits;